import { createContext, useContext, useEffect, useState } from "react";
import translations from "@/lib/translations";

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => (localStorage.getItem("quattro_lang") === "en" ? "en" : "it"));

  useEffect(() => {
    localStorage.setItem("quattro_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const setLang = (l) => setLangState(l);

  const t = (path, vars) => {
    const walk = (obj) => path.split(".").reduce((cur, p) => (cur == null ? cur : cur[p]), obj);
    let val = walk(translations[lang]);
    if (val == null) val = walk(translations.it);
    if (val == null) return path;
    if (vars && typeof val === "string") {
      Object.entries(vars).forEach(([k, v]) => { val = val.replace(new RegExp(`{${k}}`, "g"), v); });
    }
    return val;
  };

  return <LanguageContext.Provider value={{ lang, setLang, t }}>{children}</LanguageContext.Provider>;
}

export const useLang = () => useContext(LanguageContext);
